import React from 'react'
import { motion } from 'framer-motion'
import HeroSection from '../../molecules/Service/HeroSection'
import IntelligentAutomationSection from '../../molecules/Service/IntelligentAutomationSection'
import TechFoundation from '../../molecules/Service/TechFoundation'
import DevelopmentSection from '../../molecules/Service/DevelopmentSection'
import ConsultingSection from '../../molecules/Service/ConsultingSection'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import colors from '../../theme/color'
import commonfooter from '../../../assets/images/commonfooter.webp'


const ServicePage = () => {
  // 🔥 SAME animation as homepage & aboutus
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: "-100px" },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  };

  return (
    <main className="relative min-h-screen overflow-x-clip text-white" style={{ backgroundColor: colors.deepNavy }}>
      <HeroSection />

      <div className="w-full">
        <div className="w-full border-t-[3px]" style={{ borderColor: colors.purpleAlt }} />
      </div>
      
      <motion.div {...fadeUp}><IntelligentAutomationSection /></motion.div>
      
      <motion.div {...fadeUp}><TechFoundation /></motion.div>

      <DevelopmentSection />

      <motion.div {...fadeUp}><ConsultingSection /></motion.div>

      <motion.div {...fadeUp}>
      <CommanFooterCard
 paragraph="We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events."
imageSrc={commonfooter}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #874bff7d 17.11%, rgba(135, 75, 255, 0) 100%)"
/>
      </motion.div>

      <motion.div {...fadeUp}>
        <Testimonial className="mx-auto mb-20 max-w-[90%]" themeColor="purple" />
      </motion.div>

      <motion.div {...fadeUp}>
        <div className="w-full">
          <div className="mb-10 mx-2 px-4 md:px-8 lg:mx-8 lg:px-6 xl:mx-auto xl:max-w-[1400px] xl:px-8 2xl:max-w-[1800px] 2xl:px-12 min-[2560px]:max-w-[2400px] min-[2560px]:px-24">
            <div className="grid w-full grid-cols-1 gap-5 lg:grid-cols-[1fr_2fr] xl:min-h-[725px] 2xl:gap-8 min-[2560px]:min-h-[1200px] min-[2560px]:gap-16">
              <Message themeColor="purple" />
              <Questions themeColor="purple" />
            </div>
          </div>
        </div>
      </motion.div>

      <Footer />
    </main>
  )
}

export default ServicePage
